const LABEL_META = {
    safe_dark: { text: "SAFE DARK", cls: "text-[#f5f5f0] border-[#262626] bg-[#121212]" },
    edgy_but_allowed: { text: "EDGY / OK", cls: "text-[#f5f5f0] border-[#f5f5f0] bg-[#f5f5f008]" },
    platform_sensitive: { text: "SENSITIVE", cls: "text-[#ffb800] border-[#ffb800] bg-[#ffb80010]" },
    likely_restricted: { text: "LIKELY RESTRICTED", cls: "text-[#ffb800] border-[#ffb800] bg-[#ffb80018]" },
    likely_removal: { text: "LIKELY REMOVAL", cls: "text-[#ff2a2a] border-[#ff2a2a] bg-[#ff2a2a12]" },
    reject_or_rewrite: { text: "REJECT / REWRITE", cls: "text-[#ff2a2a] border-[#ff2a2a] bg-[#ff2a2a20]" },
};

export const DarkRailsBadge = ({ clip }) => {
    const dr = clip.dark_rails;
    if (!dr) return null;
    const meta = LABEL_META[dr.label] || LABEL_META.safe_dark;
    return (
        <div
            data-testid={`dark-rails-${clip.id}`}
            data-test-generic="dark-rails-badge"
            title={dr.explanation || dr.label}
            className={`inline-flex items-center gap-1 px-2 py-1 border font-mono-d8 text-[10px] uppercase tracking-widest ${meta.cls}`}
        >
            <span>◆ {meta.text}</span>
        </div>
    );
};

export default DarkRailsBadge;
